export const INSTITUTION_CONCURRENCY_USER_MESSAGE =
  "This institution was updated by someone else. Reload and try again.";

export function isInstitutionConcurrencyError(
  details: Array<Record<string, unknown>>
): boolean {
  if (!details?.length) return false;
  return details.some((detail) => {
    const status = detail?.status ?? detail?.httpStatus ?? detail?.statusCode;
    if (status === 412 || status === "412") {
      return true;
    }
    const text = [
      detail?.message,
      detail?.detail,
      detail?.title,
      detail?.code,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return /etag|concurrency|precondition|if-match|modified by another/.test(
      text
    );
  });
}
